import { fromJS } from 'immutable'

export const findIndexByStory = (state, storyId, tabFeed) => {
  return state.get(tabFeed).findIndex(item => item.getIn(['activityUserStory', 'id']) === storyId)
}

// update story in feed (recent, stories)
export const updateStoryInFeed = (state, index, field, value, tabFeed = 'recent') => {
  return state.setIn([tabFeed, index, 'activityUserStory', field], fromJS(value))
}
